var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verifyBody"},[_c('div',{staticClass:"verifyDiv"},[_c('div',{staticClass:"verify-content"},[_c('el-icon',{staticClass:"icon",attrs:{"name":"loading"}}),(!_vm.error)?_c('h1',[_vm._v("正在验证")]):_vm._e(),(_vm.error)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }